async function callApi(url,requestOption) {
    const response = await fetch(url, requestOption);
    return await response.json();
  }
  
async function callApiReturnJustResponse(url,requestOption) {
    const response = await fetch(url, requestOption);
    return await response;
  }

  export {
    callApi,
    callApiReturnJustResponse,
  };